// 14-B7d — WHAT A MEMBER ACTUALLY READS ON THE PAGE, AND NOTHING HAD EVER RUN IT.
//
// `cleanBookParagraphs` is the last thing that touches a book's text before it reaches her eyes: it
// splits the ingested page into paragraphs and DROPS two kinds of line the Sacred Texts scans carry
// on every single page — the "…, at sacred-texts.com" provenance strip, and a bare echo of the
// book's own title. Every page of every book in this library goes through it.
//
// It lived inside `src/App.tsx`, which is roadmap 7's whole argument: a pure law inside a TSX file
// cannot be imported by a `.mjs` gate, so the only instrument that could ever reach it was opening
// a book in a browser and reading. **A filter is the one shape where being slightly too greedy has
// no symptom at all** — it does not throw, it does not log, it just quietly removes a paragraph the
// author wrote, and the page still reads as a page. Out here it is a pure function a gate CALLS.
//
// Two decisions are load-bearing and both are easy to get wrong by "tidying":
//
//   • **THE TITLE ECHO IS MATCHED ON THE WHOLE PARAGRAPH, NEVER ON A PREFIX.** A paragraph that
//     BEGINS with the book's title is a sentence about the book, not a running head. Equality is
//     what keeps a chapter opening line on the page.
//   • **NORMALISATION IS FOR THE COMPARISON ONLY.** What survives is the member's paragraph exactly
//     as it was ingested, punctuation and capitals intact — the normalised form is never rendered.
//
// This module imports NOTHING (the entry requirement for `scripts/`-loadable law).

// Case, punctuation and runs of whitespace are all noise when the question is "is this line the
// title again". They are noise for the comparison and for nothing else.
export const normalizeForEcho = (s: string): string =>
  String(s ?? "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();

// The provenance strip the scans carry. `sacred-?texts` because the source writes it both ways.
export const SACRED_TEXTS_RE = /sacred-?texts\.com/i;

export function cleanBookParagraphs(content: string, title: string): string[] {
  const titleNorm = normalizeForEcho(title);
  return String(content ?? "")
    .split(/\n{2,}/)
    .map((para) => para.trim())
    .filter(Boolean)
    .filter((para) => {
      if (SACRED_TEXTS_RE.test(para)) return false;
      // Equality, not `startsWith`: a paragraph that opens with the title is prose.
      if (normalizeForEcho(para) === titleNorm) return false;
      return true;
    });
}
